import axios from "axios"
const evaluate = axios.create();
const storage = axios.create();
const backend = axios.create();
export {
    evaluate, storage, backend
}